// extracted by mini-css-extract-plugin
module.exports = {"AddReview":"AddReview_AddReview__4mfIF","group":"AddReview_group__HcspO","mark":"AddReview_mark__enwXT","overlay":"AddReview_overlay__zVsqu"};